/**
 *
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : kpozos@ibl.mx
 *
 */
import React from 'react';
import car from '../../../../../assets/defaultImages/defaultCar.svg';
import {status, STATUS_MODEL} from '../../../../../enums/statusEnum';
import {CustomCardGrid} from '../../../../../components/CustomCardGrid';
import ButtonActionsCard from '../../../../../components/buttons/ButtonActionsCard';
import RowCardText from '../../../../../components/RowCardText';
import {CustomCheckbox} from '../../../../../components/CustomCheckbox';
import NotInformation from '../../../../../components/NotInformation';
import {EMPTY_VALUES} from '../../../../../Apis/functions';
import {getViewTypeByName} from "../../../../../enums/ViewType";
import {ArrowRightIcon} from '../../../../../components/buttons/IconButtons';
import SearchSimple from "../../../../../components/SearchSimples/SearchSimple";
import MainVehiclesCardsApp from "../Functionality/MainVehiclesCardsApp";
import {statusBorderColor, statusColor, statusFontColor} from "../../../../../enums/statusColorEnum";
import {permissionObj} from "../../../../../Helpers/permission";
import CustomButtonLink from '../../../../../components/buttons/CustomButtonLink';
import routes from '../../../../../Routes/routes';

const MainVehiclesCards = ({
  view,
  selectedList,
  setSelectedList,
  option,
  bodyForExport,
  setBodyForExport,
  setSearch,
  setSimpleSearch,
  searchElement,
  setSearchElement,
  finalArray,
  isAllChecked,
  setIsAllChecked,
  setCriteria,
  modified,
  setModified,
  showActionsContractorSupplier
}) => {

    const {
        t,
        DEV,
        permission,
        contractorId,
        supplierId,
        results,
        setResults,
        rowsPerPage,
        handleCheckboxChange,
        handleDeleteAll,
        pagination,
        elementRef,
        handleOnClick, 
        navigate,
    } = MainVehiclesCardsApp({
        view,
        selectedList,
        setSelectedList,
        option,
        setBodyForExport,
        searchElement,
        finalArray,
        setIsAllChecked,
        setCriteria,
        modified,
        setModified
    });

    return (
        <>
            <SearchSimple
                id={"txt_av_search_simple"}
                setBodyForExport={setBodyForExport}
                bodyForExport={bodyForExport}
                setSearchResults={setResults}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                optionTable={option}
                rowsPerPage={rowsPerPage}
                setSearch={setSearch}
                setSimpleSearch={setSimpleSearch}
                contractorId={contractorId}
                supplierId={supplierId}
                viewType={getViewTypeByName(view)}
            />

            {results?.content?.length > 0 ? (
                <>
                    <div>
                        <CustomCheckbox id={"cb_mvc_all_checked"}
                            trans={'de_/_select_all'}
                            name={'isAllChecked'}
                            checked={isAllChecked}
                            onChange={(e) => handleDeleteAll(e)}
                        />
                    </div>
                    <div className='panelTables' ref={elementRef}>
                        <div className='row'>
                        {results?.content?.map((item, index) => {
                            const showButton = ((contractorId || supplierId) && (showActionsContractorSupplier || item?.periodId))
                                || DEV || permission?.includes(permissionObj?.WEB_VEHICLE_UPDATE);
                            const buttonText = (contractorId || supplierId) && item?.periodId ? 'documentation': 'update';

                            return <CustomCardGrid
                                itemId={item?.id}
                                checked={selectedList?.includes(item?.id)}
                                onCheckboxChange={handleCheckboxChange}
                                disabled={false}
                                statusColor={statusColor[item?.statusId]}
                                fontColor={statusFontColor[item?.statusId]}
                                borderColor={statusBorderColor[item?.statusId]}
                                statusName={t(status[item?.statusId])}
                                srcImage={item?.image ? `data:image/png;base64,${item?.image}` : car}
                                backgroundImage={item?.image ? `data:image/png;base64,${item?.image}` : ''}
                                btnActions={(showButton) ?
                                        <ButtonActionsCard
                                            id={`btn_mvc_actions_card_${index + 1}`}
                                            name={buttonText}
                                            Icon={ArrowRightIcon}
                                            onClick={() => {
                                                handleOnClick(contractorId, supplierId, item)
                                            }}
                                        />
                                        : ''
                                }
                                classNamePanelGrid={"col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 px-1 mb-3"}
                                chipVariant={"large"}
                                >
                                <RowCardText title={t('brand')} value={item?.brand || EMPTY_VALUES.DEFAULT} />
                                <RowCardText title={t('sub_brand')} value={item?.subBrand || EMPTY_VALUES.DEFAULT} />
                                <RowCardText title={t('model')} value={item?.model || EMPTY_VALUES.DEFAULT} />
                                <RowCardText title={t('color')} value={item?.color || EMPTY_VALUES.DEFAULT} />
                                <RowCardText title={t('plates')} value={item?.plate || EMPTY_VALUES.DEFAULT} />
                                <RowCardText title={t('vin')} value={item?.vin || EMPTY_VALUES.DEFAULT} />
                                <RowCardText title={t('serial_number')} value={item?.serialNumber || EMPTY_VALUES.DEFAULT} />
                                </CustomCardGrid>
                            })}
                        </div>
                    </div>
                    {pagination()}
                </>
            ) : (
                <NotInformation>
                    <>
                        <div className='warning-text'>
                            <p>{t('you_have_not_created_any_vehicles_yet')}</p>
                        </div>
                        {(contractorId ||
                            supplierId ||
                            DEV ||
                            permission?.includes(permissionObj?.WEB_VEHICLE_CREATE)) && (
                            <CustomButtonLink
                                splitName={false}
                                id='btn_mvc_create'
                                card={true}
                                onClick={() =>
                                    navigate(
                                        supplierId
                                            ? routes.vehicleSupplier.create
                                            : contractorId
                                              ? routes.vehicleContractor.create
                                              : routes.vehicleFleet.create,
                                    )
                                }
                                name='create_new_vehicle'
                            />
                        )}
                    </>
                </NotInformation>
            )}
        </>
    );
};

export default MainVehiclesCards;
